import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierMinusOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="M10.497 7.95v-1.4h-6.5v1.4z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.247.497c-5.063 0-6.75 3.375-6.75 6.75s1.687 6.75 6.75 6.75c1.952 0 3.402-.502 4.448-1.313L14.51 15.5l.99-.99-2.822-2.822c.94-1.24 1.319-2.84 1.319-4.441 0-3.375-1.688-6.75-6.75-6.75M3.049 3.502c-.78.936-1.152 2.265-1.152 3.745s.372 2.809 1.152 3.744c.742.89 2.003 1.606 4.198 1.606 2.194 0 3.456-.716 4.198-1.606.779-.935 1.152-2.265 1.152-3.744s-.373-2.81-1.152-3.745c-.742-.89-2.004-1.605-4.198-1.605s-3.456.715-4.198 1.605"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierMinusOutlinedSize16Glyph.displayName = 'MagnifierMinusOutlinedSize16Glyph';
